import { useSettings } from '../store/settings';
/** Drag to resize the feed/launcher panel; width persists. Keyboard: arrows adjust by 20px. */
export function Resizer({ side }: { side: 'left' | 'right' }) {
  const set = useSettings((s) => s.set);
  const start = (e: React.PointerEvent) => {
    const x0 = e.clientX, w0 = useSettings.getState().feedWidth;
    const move = (ev: PointerEvent) => { const d = ev.clientX - x0; set({ feedWidth: clamp(w0 + (side === 'left' ? d : -d)) }); };
    const up = () => { window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); };
    window.addEventListener('pointermove', move); window.addEventListener('pointerup', up);
  };
  return <div className="resizer" role="separator" aria-orientation="vertical" tabIndex={0} onPointerDown={start}
    onKeyDown={(e) => { const w = useSettings.getState().feedWidth; if (e.key === 'ArrowLeft') set({ feedWidth: clamp(w + (side === 'left' ? -20 : 20)) }); if (e.key === 'ArrowRight') set({ feedWidth: clamp(w + (side === 'left' ? 20 : -20)) }); }} />;
}
const clamp = (w: number) => Math.max(300, Math.min(Math.round(window.innerWidth * 0.45), w));
